module.exports = __webpack_public_path__ + "static/media/eva.5f18e0d0.png";